module.exports = __webpack_public_path__ + "img/arrow-ios-back.daddc8c2.svg";